var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.map.id},on:{"click":_vm.onClick}},[_c('img',{attrs:{"id":_vm.map.id,"src":_vm.map.asset.src}}),_vm._v(_vm._s(_vm.map.id))])}
var staticRenderFns = []

export { render, staticRenderFns }